var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 mb-3"},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }